import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-water-network',
  templateUrl: './certificate-water-network.component.html',
  styleUrls: ['./certificate-water-network.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateWaterNetworkComponent extends CertificateComponent {
  title = `דו"ח בדיקת אופיין רשת מס'`;
  subTitle = `דו"ח זה מחליף ומתקן את הדו"ח מספר`;
}
